import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import { Container, Row, Col, Image, Card, Popover, OverlayTrigger } from 'react-bootstrap';
import HR from '../Components/HR';
import FormFeed from '../Components/FormFeed';
import FormTable from '../Components/FormTable';
import { adjustData } from '../Data/data';
import Paragraph from '../Components/Paragraph';

const Adjust = (props) => {

    // Popover-ikkuna, jossa valintavihjeet esitellään hoverin/focuksen kautta
    const popover = (
        <Popover id="popover-basic">
            <Popover.Header as="h3">{props.popover.header}</Popover.Header>
            <Popover.Body>
                { props.popover.list.map((item, index) => {
                    return <li key={props.data.id + "generalHint" + index}>{item}</li>
                }) }
            </Popover.Body>
        </Popover>
    )
    
    // Tilakoukku huolehtimaan focuksesta
    useEffect(() => {
        if(props.init !== props.data.id) {
            window.scrollTo(0, 0)
            props.setFocusId(props.data.id + "head")
            props.setInit(props.data.id)
        } else { 
            document.getElementById(props.focusId).focus()
        }
      }, [props])

    return (
        <Container role="main" className="content" fluid>
            <Row role="img" aria-label="Vinkkikuvat aihealueeseen liittyen" className="d-none d-md-flex">
                <Col md={3} className="">
                    <Image src={props.data.images.pic1} alt={props.data.alts.pic1alt} className="adjustImage" rounded fluid />
                </Col>
                <Col md={3} className="">
                    <Image src={props.data.images.pic2} alt={props.data.alts.pic2alt} className="adjustImage" rounded fluid />
                </Col>
                <Col md={3} className="">
                    <Image src={props.data.images.pic3} alt={props.data.alts.pic3alt} className="adjustImage" rounded fluid />
                </Col>
                <Col md={3} className="">
                    <Image src={props.data.images.pic4} alt={props.data.alts.pic4alt} className="adjustImage" rounded fluid />
                </Col>
            </Row>
            <Row className="mt-4 container-fluid adjustTitle">
                <Card className="" border='dark'>
                    <Card.Title id={props.data.id + "head"} className="pt-3" role="heading" aria-level="2" tabIndex="0">{adjustData.help.header} {props.header}</Card.Title>
                    <HR />
                    <Card.Text className="p-1" title="Ohje" tabIndex="0">
                        {adjustData.help.text}
                    </Card.Text>
                    <OverlayTrigger trigger={['hover', 'focus']} placement={props.popoverDirection} overlay={popover}>
                        <Container className="choiceQuestion" tabIndex="0"><Paragraph classes="adjustInfo" text={"?"} /></Container>
                    </OverlayTrigger>
                </Card>
            </Row>
            <Row className="mt-4">
                <FormFeed plusList={props.plusList} setPlusList={props.setPlusList} minusList={props.minusList} setMinusList={props.setMinusList} label={props.data.label} setFocusId={props.setFocusId} />
            </Row>
            <Row className="mt-4">
                <FormTable plusList={props.plusList} minusList={props.minusList} setPlusList={props.setPlusList} setMinusList={props.setMinusList} />
            </Row>
            <Row className='adjustBtn2 w-25 m-auto mt-4'>
                <Link to={props.data.links.next} title="Siirry eteenpäin" className="btn mainButton">{adjustData.buttons.confirmOne}</Link>
            </Row>
        </Container>
    );
};

export default Adjust;